import React from 'react';
import { Panel, Button, Social, SocialLink, fb, tw } from './styles';

const share = (event, root) => {
	var escaped = encodeURIComponent(window.location.href);
	if (window.open(root + escaped, '', 'width=550,height=400')) {
		event.preventDefault();
	}
}

const shareFb = event => {
	share(event, 'https://www.facebook.com/sharer/sharer.php?u=');
}

const shareTwitter = event => {
	share(event, 'https://twitter.com/share?url=');
}

export default class Refresh extends React.PureComponent {

	timeout = null;

	componentDidMount() {
		this.setup();
	}

	componentDidUpdate() {
		this.setup();
	}

	componentWillUnmount() {
		this.teardown();
	}

	setup() {
		this.teardown();
		if (this.props.canUpdate) {
			this.timeout = setInterval(this.props.onClick, 60e3);
		}
	}

	teardown() {
		if (this.timeout) {
			clearInterval(this.timeout);
			this.timeout = null;
		}
	}

	render() {
		const { canUpdate, onClick } = this.props;

		return <Panel>
			{canUpdate && <Button onClick={onClick} />}
			<Social>
				<SocialLink className={fb} href="#" onClick={shareFb} />
				<SocialLink className={tw} href="#" onClick={shareTwitter} />
			</Social>
		</Panel>;
	}
}
